import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { FolderSummaryDto } from '../models/folder-summary.dto';
import { MergeBeneficiarySearchDto } from '../models/merge-beneficiairy-search.dto';
import { MergeBeneficiaryDto } from '../models/merge-beneficiary.dto';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class MergeService {
  constructor(
    private readonly http: HttpClient,
    private readonly api: ApiService,
  ) {}

  public search(term: string, limit: number = 100): Observable<MergeBeneficiarySearchDto[]> {
    return term
      ? this.http
          .get<any[]>(environment.api.merge + '?q=' + term + '&limit=' + limit)
          .pipe(map((res: any[]) => (res || []).map(MergeBeneficiarySearchDto.fromJson)))
      : of([]);
  }

  public async merge(mergeDto: MergeBeneficiaryDto): Promise<void> {
    return this.api.post(environment.api.merge + '/mergebeneficiaries', mergeDto);
  }

  public getFolderSummary(beneficiaryId: number): Observable<FolderSummaryDto> {
    return this.http.get<FolderSummaryDto>(environment.api.merge + '/numbers/' + beneficiaryId);
  }
}
